import { Controller } from "@hotwired/stimulus"

/*
  AccountAppDetailsController

  Lazily loads the per-app detail panel on the admin account page. The counts in
  that panel are one query each, so fetching them only when a row is expanded
  keeps the page load free of per-app queries.

  Example:
  <tbody
    data-controller="account-app-details"
    data-account-app-details-url-value="/admin/accounts/acme/app_details/123"
  >
    <tr>
      <td><div data-action="click->account-app-details#toggle">➕</div></td>
    </tr>
    <tr class="hidden" data-account-app-details-target="row">
      <td data-account-app-details-target="panel"></td>
    </tr>
  </tbody>
*/

export default class extends Controller {
  static targets = ["row", "panel"]
  static values = { url: String }

  loaded = false

  async toggle() {
    this.rowTarget.classList.toggle("hidden")

    if (this.rowTarget.classList.contains("hidden") || this.loaded) {
      return
    }

    this.loaded = true
    this.panelTarget.textContent = "Loading…"

    try {
      const response = await fetch(this.urlValue, {
        headers: { "X-Requested-With": "XMLHttpRequest" }
      })

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
      }

      this.panelTarget.innerHTML = await response.text()
    } catch (error) {
      this.loaded = false
      this.panelTarget.textContent = "Could not load app details. Try again."
      console.error(error)
    }
  }
}
